import Controller from '@ember/controller';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class FundsNoAccessController extends Controller {
  @service declare router: RouterService;

  @action
  templateDidInsert() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  @action
  templateWillDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  @action
  handleKeyDown() {
    // automatically transition to funds page if the user presses any key
    this.router.transitionTo('funds.index');
  }
}
